export default {
  'clocks': [
    'clock0900_1230',
    'clock1330_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ]
  }
}
